import { abcRuleDataSchema } from "@redotech/redo-inventory-common/cycle-counts";
import {
  cycleCountRuleIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const previewAbcCycleCountRule = unaryRpc({
  name: "previewAbcCycleCountRule" as const,
  input: z.object({
    ruleId: cycleCountRuleIdFormat.schema.nullish(),
    data: abcRuleDataSchema,
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        sku: z.string().nullable(),
        title: z.string(),
        locationId: locationIdFormat.schema,
        locationName: z.string(),
        onHandQuantity: z.bigint(),
        lastCountedAt: z.date().nullable(),
        metricValue: z.number(),
        tier: z.enum(["A", "B", "C"]),
      }),
    ),
  }),
});
